module.exports = __webpack_public_path__ + "public/img/Menggunakan Bahasa Inggris Bagi Staf Admin.f4e98f67.png";